import React from "react";
// import img1 from "../../assets/AboutUs/image1.jpg";


export default function Aboutus() {
  return (
    // <div className="about-section">
    //   <div className="section-header">
    //     <h1>What do we do?</h1>
    //   </div>

    //   <div className="about-row ">
    //     <div className="about-desc">
    //       <div className="about-row">
    //         <h1 className="about-us-header">About Us</h1>
    //       </div>
    //       Project MANAS is the official AI and Robotics team of MAHE, Manipal
    //       established in 2014. We are the Grand Prize winners and won the Lescoe
    //       Cup at the Intelligent Ground Vehicle Competition which is held at
    //       Michigan. Our aim is to build India’s first driverless car and are
    //       among the top 13 participants in the Mahindra’s Rise Prize challenge.
    //     </div>
    //     <div className="about-rotated">ABOUT</div>
    //     <div className="image1"></div>
    //   </div>

    //   <div className="about-row-alt">
    //     <div className="about-desc">
    //       <h1 className="vision-header">Vision</h1>
    //       Project MANAS aims to inspire advanced research in Artificial
    //       Intelligence and oversee its implementation enabling automated systems
    //       to be made available to general populous.
    //       <h1 className="vision-header">Mission</h1>
    //       Our mission is to uphold the tradition of pushing the limits of
    //       Artificial Intelligence and Bringing Bits to Life.
    //     </div>
    //     <div className="about-rotated">VISION</div>
    //     <div className="image1"></div>
    //   </div>
    //</div>

    <div className="about-section" id="about">
      <div className="filler"></div>
      <div className="section-header">
        <h1>
          <span>About</span> Us
        </h1>
        <div className="header-underline"></div>
      </div>

      <div className="about-row">
        <div className="about-desc">
          <div className="about-row">
            <h1 className="about-us-header">Who are we?</h1>
          </div>
          <div className="desc">
          Project MANAS is the official AI & Robotics Student Research and Development Team of  MAHE, Manipal, established in 2014. Since then, we've grown from Mahindra’s Rise Prize challenge’s self-driving car to spanning autonomous ground vehicles and aerial systems that hold it all together. Our machines have placed on the podium at IGVC, SUAS, and NIDAR. We don't just build robots for competitions; we build engineers who can ship real systems under real constraints.
          </div>
          <br />
          <br />
          <div className="about-row">
            <h1 className="about-us-header-small">Vision</h1>
          </div>
          <div className="desc">
          Project MANAS envisions a future where autonomous intelligence is engineered in India, by students, trusted anywhere in the world.
          </div>
          <br />
          <div className="about-row">
            <h1 className="about-us-header-small mission">Mission</h1>
          </div>
          <div className="last">
          Project MANAS aims to push the boundaries of autonomous vehicles and robotic systems that compete on the global stage, all while Bringing Bits to Life.
          </div>
        </div>
        <div className="image1"></div>
      </div>
    </div>
  );
}
